var map = {
	"./bg_cutting_paper.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/bg_cutting_paper.png",
	"./bg_girl_talking.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/bg_girl_talking.png",
	"./bg_pointing_flower.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/bg_pointing_flower.png",
	"./boy_on_horse.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/boy_on_horse.gif",
	"./boy_on_horse.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/boy_on_horse.png",
	"./cover_banner.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/cover_banner.png",
	"./cover_page.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/cover_page.png",
	"./cover_page1.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/cover_page1.png",
	"./dashain.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/dashain.gif",
	"./dashain1920x1080.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/dashain1920x1080.png",
	"./girl_cutting_paper.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_cutting_paper.gif",
	"./girl_cutting_paper.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_cutting_paper.png",
	"./girl_pointing_flower.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_pointing_flower.gif",
	"./girl_pointing_flower.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_pointing_flower.png",
	"./girl_pointing_ring.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_pointing_ring.gif",
	"./girl_pointing_ring.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_pointing_ring.png",
	"./girl_talking.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_talking.gif",
	"./girl_talking.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/girl_talking.png",
	"./grandparents.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/grandparents.gif",
	"./grandparents.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/grandparents.png",
	"./horse_on_window.gif": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/horse_on_window.gif",
	"./horse_on_window.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/horse_on_window.png",
	"./last_page.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/last_page.png",
	"./pointing_horse.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/pointing_horse.png",
	"./pointing_ring.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/pointing_ring.png",
	"./pointing_ring_01.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/pointing_ring_01.png",
	"./ring_to_friend.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/ring_to_friend.png",
	"./ring_to_friend1.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/ring_to_friend1.png",
	"./ring_to_king.png": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/ring_to_king.png",
	"./story-banner.svg": "./src/EGRContent/Story/GhodaMeroChadaiCha/images/story-banner.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/EGRContent/Story/GhodaMeroChadaiCha/images sync recursive ^\\.\\/.*$";